var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#tiktok_svg__paint0_linear_427_109502)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tiktok_svg__filter0_i_427_109502)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17.048a8.51 8.51 0 004.966 1.577v-3.53a4.773 4.773 0 01-1.04-.11v2.81a8.504 8.504 0 01-4.971-1.594v7.258a6.603 6.603 0 01-3.485 5.796 6.588 6.588 0 01-6.751-.32A6.591 6.591 0 0024.5 24.324v-7.276zm1.288-3.599a4.937 4.937 0 01-1.287-2.905v-.459h-.987a4.99 4.99 0 002.274 3.364zM15.504 26.141a3.013 3.013 0 012.416-4.84c.31 0 .62.047.916.14v-3.646a6.928 6.928 0 00-1.046-.058v2.834a3.012 3.012 0 00-3.7 1.738 3.02 3.02 0 001.432 3.832h-.018z",
    fill: "#EE1D52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.455 16.178a8.503 8.503 0 004.971 1.594V14.96a4.959 4.959 0 01-2.638-1.512 4.985 4.985 0 01-2.274-3.364h-2.598v14.239a3.019 3.019 0 01-2.055 2.848 3.013 3.013 0 01-3.356-1.031 3.015 3.015 0 01-1.576-3.39 3.018 3.018 0 012.927-2.32c.311 0 .62.048.917.14v-2.834a6.583 6.583 0 00-5.943 4.105 6.598 6.598 0 001.389 7.093 6.589 6.589 0 009.311-2.088 6.603 6.603 0 00.943-3.388l-.018-7.281z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.424 14.96v-.759a4.927 4.927 0 01-2.638-.752c.698.77 1.621 1.299 2.638 1.511zm-4.912-4.876c0-.135-.041-.276-.06-.411v-.459h-3.584V23.46a3.012 3.012 0 01-4.365 2.681 3.014 3.014 0 005.411-1.817V10.084h2.598zM17.77 17.73v-.806a6.582 6.582 0 00-7.046 4.194 6.598 6.598 0 002.492 7.816 6.595 6.595 0 014.571-11.174l-.017-.03z",
    fill: "#69C9D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiktok_svg__paint0_linear_427_109502",
    x1: 0.813,
    y1: 0,
    x2: 35.231,
    y2: 43.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tiktok_svg__filter0_i_427_109502",
    x: 7.586,
    y: 7.588,
    width: 24.391,
    height: 24.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_427_109502"
  })))));
}

export default SvgTiktok;